import { useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import { AppContext } from "../../provider/AppProvider";

import { useNavigate, useSearchParams } from "react-router-dom";
import { copyCanvas } from "../../utils/imageUtils";
import { CanvasVideoElem } from "../../entities";

import logo from "../Test/logo.png";
import { getStorageUrl } from "../../utils/db";
import { CachedImage } from "../../components/CachedImage/CachedImage";

const templateTileSize = "20em"

const useSetTestDuration = () => {
  const {
    duration,
    setDuration
  } = useContext(AppContext);

  const [searchParams, setSearchParams] = useSearchParams();

  useLayoutEffect(() => {
    const _duration = Number(searchParams.get('test') || searchParams.get('duration')) * 1000
    console.log('_duration', _duration)
    if (_duration) {

      setDuration({ ...duration, pose: Number(_duration), preview: Number(_duration), finalPreview: Number(_duration) })
    }
  }, [searchParams])
}

const useCamPreviewTile = () => {
  const {
    setRec,
    setFrameCallback,
    pauseBgRemoval,
  } = useContext(AppContext);

  useEffect(() => {
    setRec(true);
    pauseBgRemoval(true);
    setFrameCallback((cutout: CanvasVideoElem) => {
      copyCanvas(cutout, screenCanvasRef.current);
    });
  }, []);

  const screenCanvasRef = useRef<HTMLCanvasElement>(null);

  const camPreview = (<div style={{ position: "fixed", bottom: "32px", right: "32px", borderRadius: "8px", overflow: 'hidden' }}>
    <canvas
      ref={screenCanvasRef}
      style={{ width: "240px", objectFit: "contain" }}
    />
  </div>)

  return { camPreviewTile: camPreview }
}

const useTemplateThumbUrls = (templateNames: string[]) => {
  useEffect(() => {
    loadTemplates(templateNames)
  }, [])

  const [thumbUrls, setThumbUrls] = useState<string[]>([])

  const loadTemplates = async (templateNames: string[]) => {
    const result = await Promise.all(templateNames.map(name => getStorageUrl(`/ps42Templates/thumbs/${name}.zip.webp`)))
    setThumbUrls(result)
  }

  return { thumbUrls }
}

const templateTileStyle = {
  cursor: "pointer",
  height: templateTileSize,
  borderRadius: "8px",
  "&:hover": {
    border: "solid 4px green",
    boxShadow: "0 0 20px 5px rgba(0, 255, 255, 0.7)"
  }
}

interface DashboardProps {
  templates?: string[]
}

const Dashboard: React.FC<DashboardProps> = ({ templates = ["travel"] }) => {
  const nav = useNavigate();
  // const templates = 

  // set the duration from the url search param
  useSetTestDuration()

  // camera preview
  const { camPreviewTile } = useCamPreviewTile()
  const { thumbUrls } = useTemplateThumbUrls(templates || ["travel"])


  const logoDisplay = <div style={{ position: "fixed", top: "2em", bottom: "2em" }}>
    <img src={logo} style={{ position: "absolute", width: "400px", left: "calc(100%-200px)", top: "calc(-10px)" }} />
  </div>

  const templateSelectButtons = templates.map((_name, i) => (
    <CachedImage
      src={thumbUrls[i]}
      style={templateTileStyle}
      onClick={() => nav(`/ps42/${templates[i]}`)}
    />

  ))
  const tileGallery = <div style={{ justifyContent: "center", padding: "1em", display: "flex", gap: "1em", width: "100%", flexWrap: "wrap" }}>
    {templateSelectButtons}
  </div>

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "radial-gradient(circle at top center, rgba(12,71,93,1)0%, rgba(16,22,39,1) 95%)" }}>
        <div style={{ padding: "8px", width: "100%" }}>
          {tileGallery}
          {/* <Button style={{position: "fixed", padding: "32px", left: 0, bottom: 0}} onClick={()=>window.print()}>Print</Button> */}
        </div>
      </div>
      {camPreviewTile}
      {logoDisplay}
    </>
  );
};

export default Dashboard;
